// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_SdJ-y","number-row":"index_number-row_Qwqh5","footer":"index_footer_1Xl4z"};